import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import styled from 'styled-components';

const Container = styled.div`
  max-width: 600px;
  margin: 4rem auto;
  padding: 2rem;
  text-align: center;
`;

const SuccessIcon = styled.div`
  color: #4CAF50;
  font-size: 4rem;
  margin-bottom: 2rem;
  
  &::before {
    content: '✓';
  }
`;

const Title = styled.h1`
  font-size: 2rem;
  margin-bottom: 1rem;
  color: #333;
`;

const Message = styled.p`
  font-size: 1.1rem;
  color: #666;
  margin-bottom: 2rem;
  line-height: 1.6;
`;

const AdditionalMessage = styled.p`
  font-size: 1rem;
  color: #FF1493;
  margin-bottom: 1.5rem;
  line-height: 1.5;
  font-weight: 500;
`;

const Button = styled.button`
  background-color: #FF1493;
  color: white;
  border: none;
  border-radius: 25px;
  padding: 0.75rem 1.5rem;
  font-size: 1rem;
  font-weight: bold;
  cursor: pointer;
  margin: 0.5rem;
  transition: background-color 0.2s;
  
  &:hover {
    background-color: #ff0080;
  }
`;

const PurchaseSuccessScreen = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const additionalMessage = location.state?.additionalMessage || '';

  return (
    <Container>
      <SuccessIcon />
      <Title>Purchase Successful!</Title>
      <Message>
        Thank you for your purchase! We've sent a confirmation email with your order details.
        The seller will be notified and will contact you regarding shipping arrangements.
      </Message>
      {additionalMessage && (
        <AdditionalMessage>{additionalMessage}</AdditionalMessage>
      )}
      <div>
        <Button onClick={() => navigate('/profile/purchases')}>
          View My Purchases
        </Button>
        <Button onClick={() => navigate('/')}>
          Return to Marketplace
        </Button>
      </div>
    </Container>
  );
};

export default PurchaseSuccessScreen; 